export default "__VITE_ASSET__B8BmeB8d__"